import React from 'react'
import styled from 'styled-components'
import { LargeWrapper } from '@raysync/common/components'
import { Devices } from '@raysync/common/theme'
import { Title, Desc } from '../atoms'
const Section = styled.section`
  padding: 70px 0 96px;
  background: #f5f7fb;
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 0.7rem;
  }
`
const Container = styled.div`
  svg {
    display: block;
    margin: 50px auto 0;
    max-width: 1040px;
  }
`

const Solution = ({ title, desc, svg }) => {
  return (
    <Section>
      <LargeWrapper>
        <Title>{title}</Title>
        {desc && <Desc>{desc}</Desc>}
        <Container>{svg}</Container>
      </LargeWrapper>
    </Section>
  )
}

export default Solution
